/* QUIETUDE — product rail: arrows, progress bar, and add-to-cart.
   The rail is a native scroll container, so swipe and keyboard already work;
   the controls only page it and mirror its position.

   After an add, the cart drawer is opened through window.qtOpenCart, defined
   by quietude-drawer.js. Guarded, so the rail still works on a page where the
   drawer is not rendered. */
(function () {
  if (window.__qtRailBound) return;
  window.__qtRailBound = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scope) {
    (scope || document).querySelectorAll('[data-rail-root]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';

      var rail = root.querySelector('[data-rail]');
      if (!rail) return;
      var dots = [].slice.call(root.querySelectorAll('[data-rail-dot]'));

      function step() {
        var card = rail.querySelector('.hy-card');
        if (!card) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function sync() {
        var max = rail.scrollWidth - rail.clientWidth;
        root.querySelectorAll('[data-rail-dir]').forEach(function (b) {
          var dir = parseInt(b.getAttribute('data-rail-dir'), 10);
          b.disabled = dir < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
        });
        if (dots.length) {
          var i = max > 0 ? Math.round(rail.scrollLeft / max * (dots.length - 1)) : 0;
          dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
        }
      }

      root.querySelectorAll('[data-rail-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          rail.scrollBy({ left: step() * parseInt(btn.getAttribute('data-rail-dir'), 10),
                          behavior: reduced ? 'auto' : 'smooth' });
        });
      });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          var max = rail.scrollWidth - rail.clientWidth;
          rail.scrollTo({ left: max / Math.max(dots.length - 1, 1) * i,
                          behavior: reduced ? 'auto' : 'smooth' });
        });
      });

      var raf = null;
      rail.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; sync(); });
      }, { passive: true });

      sync();
      window.addEventListener('resize', sync);
    });

    /* Add to cart straight from a card, then slide the drawer in. */
    (scope || document).querySelectorAll('[data-quick-add]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-quick-add');
        if (!id || !window.fetch) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || 'Could not add');
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.querySelectorAll('.hy-count, .mm-count, .cart-count').forEach(function (c) {
              c.textContent = cart.item_count;
            });
            if (typeof window.qtOpenCart === 'function') window.qtOpenCart(cart);
          })
          .catch(function () {})
          .finally(function () { setTimeout(function () { btn.disabled = false; }, 800); });
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();